var Organization;

import Base from './base.js';

export default Organization = class Organization extends Base {};
